<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="5" :sm="24">
                <a-form-item label="商品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入商品名称查询" v-model="queryParam.materialName"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item label="供应商" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    v-model="queryParam.supplierId"
                    showSearch
                    optionFilterProp="children"
                    placeholder="请选择供应商"
                    allowClear
                    style="width: 100%">
                    <a-select-option v-for="s in supplierOptions" :key="s.id" :value="s.id">
                      {{ s.supplierName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="4" :sm="24">
                <a-checkbox v-model="queryParam.onlyUnset" @change="searchQuery">只看未设置</a-checkbox>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="10" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator" style="margin-bottom: 16px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="setting" @click="handleBatchSet">批量设置供应商</a-button>
          <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="确定清除所选商品的全部供应商归属吗?" @confirm="handleBatchClear">
            <a-button icon="close">批量清除归属</a-button>
          </a-popconfirm>
          <span style="margin-left: 8px; color: #999">已选 {{ selectedMaterialIds.length }} 个商品</span>
        </div>
        <section>
          <a-table
            ref="table"
            size="middle"
            bordered
            :rowKey="rowKeyOf"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            @change="handleTableChange">
            <template slot="supplier" slot-scope="text, record">
              <span v-if="record.supplierId">
                {{ record.supplierName }}
                <a-tag v-if="isDefaultRow(record)" color="blue">默认</a-tag>
              </span>
              <a-tag v-else color="orange">未设置</a-tag>
            </template>
            <span slot="action" slot-scope="text, record">
              <template v-if="btnEnableList.indexOf(1)>-1">
                <a v-if="!record.supplierId" @click="handleSet(record)">设置</a>
                <template v-else>
                  <a v-if="!isDefaultRow(record)" @click="handleSetDefault(record)">设为默认</a>
                  <a-popconfirm title="确定删除该商品的此供应商归属吗?" @confirm="() => handleRemoveRow(record)">
                    <a :style="isDefaultRow(record) ? '' : 'margin-left: 8px'">删除</a>
                  </a-popconfirm>
                </template>
              </template>
              <span v-else>-</span>
            </span>
          </a-table>
        </section>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />
        <!-- 设置弹窗：供应商多选，所选第一个为默认（拆分取默认供应商） -->
        <a-modal
          :title="setTitle"
          :visible="setVisible"
          :confirmLoading="setLoading"
          :maskClosable="false"
          @ok="handleSetOk"
          @cancel="setVisible = false">
          <a-form-item label="供应商" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
            <a-select
              v-model="setSupplierIds"
              mode="multiple"
              showSearch
              optionFilterProp="children"
              placeholder="请选择供应商（可多选，第一个为默认）"
              style="width: 100%">
              <a-select-option v-for="s in supplierOptions" :key="s.id" :value="s.id">
                {{ s.supplierName }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <div style="color: #999; margin-left: 8px">一个商品可配多个供应商，其中第一个为默认；采购拆分自动分给默认供应商。</div>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getSupplierArchives, setMaterialSuppliers, clearMaterialSuppliers, removeMaterialSupplierRows } from '@/api/plugin/orderReceive'

export default {
  name: 'MaterialSupplierList',
  mixins: [JeecgListMixin],
  data() {
    return {
      labelCol: {
        span: 7
      },
      wrapperCol: {
        span: 16,
        offset: 1
      },
      urlPath: '/plugin/order-receive/materialsupplier',
      queryParam: {
        materialName: '',
        supplierId: undefined,
        onlyUnset: false
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '商品名称',
          dataIndex: 'materialName',
          width: 240
        },
        {
          title: '型号',
          dataIndex: 'materialModel',
          width: 140
        },
        {
          title: '单位',
          dataIndex: 'materialUnit',
          width: 80,
          align: 'center'
        },
        {
          title: '供应商',
          key: 'supplier',
          scopedSlots: { customRender: 'supplier' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/material-suppliers'
      },
      supplierOptions: [],
      selectedRowKeys: [],
      setTitle: '设置供应商',
      setVisible: false,
      setLoading: false,
      setSupplierIds: [],
      setTargetIds: []
    }
  },
  computed: {
    /** 勾选行对应的商品ID（一对多展开行去重） */
    selectedMaterialIds() {
      const ids = []
      const seen = {}
      this.dataSource.forEach((r) => {
        if (this.selectedRowKeys.indexOf(this.rowKeyOf(r)) > -1 && r.materialId && !seen[r.materialId]) {
          seen[r.materialId] = true
          ids.push(r.materialId)
        }
      })
      return ids
    }
  },
  created() {
    this.loadSuppliers()
  },
  methods: {
    /** 一对多展开行 key：已设行用归属行id，未设行用商品id */
    rowKeyOf(record) {
      return record.id ? 'r' + record.id : 'm' + record.materialId
    },
    isDefaultRow(record) {
      return Number(record.isDefault) === 1
    },
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        materialName: this.queryParam.materialName,
        supplierId: this.queryParam.supplierId,
        onlyUnset: this.queryParam.onlyUnset ? true : undefined
      }
    },
    loadSuppliers() {
      getSupplierArchives({}).then((res) => {
        if (res.code === 200) {
          this.supplierOptions = res.data || []
        }
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleSet(record) {
      this.setTargetIds = [record.materialId]
      this.setSupplierIds = []
      this.setTitle = '设置供应商 - ' + record.materialName
      this.setVisible = true
    },
    handleBatchSet() {
      const materialIds = this.selectedMaterialIds
      if (materialIds.length === 0) {
        this.$message.warning('请先勾选商品')
        return
      }
      this.setTargetIds = materialIds
      this.setSupplierIds = []
      this.setTitle = '批量设置供应商（已选 ' + materialIds.length + ' 个商品）'
      this.setVisible = true
    },
    /** 提交：所选第一个供应商 isDefault=true，其余 false */
    handleSetOk() {
      if (!this.setSupplierIds.length) {
        this.$message.warning('请选择供应商')
        return
      }
      this.setLoading = true
      const materialIds = this.setTargetIds
      let chain = Promise.resolve()
      this.setSupplierIds.forEach((supplierId, idx) => {
        chain = chain.then(() => setMaterialSuppliers({
          materialIds: materialIds,
          supplierId: supplierId,
          isDefault: idx === 0
        }).then((res) => {
          if (res.code !== 200) {
            throw { message: res.message || '设置失败' }
          }
        }))
      })
      chain.then(() => {
        this.$message.success('设置成功')
        this.setVisible = false
        this.selectedRowKeys = []
        this.loadData()
      }).catch((err) => {
        this.$message.warning((err && err.message) || '设置失败')
      }).finally(() => {
        this.setLoading = false
      })
    },
    /** 行级设为默认：清同商品其它默认后回填 */
    handleSetDefault(record) {
      setMaterialSuppliers({
        materialIds: [record.materialId],
        supplierId: record.supplierId,
        isDefault: true
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('已设为默认')
          this.loadData()
        } else {
          this.$message.warning(res.message || '设置失败')
        }
      })
    },
    /** 行级删除该供应商归属（删默认行后该商品无默认，拆分进待分配） */
    handleRemoveRow(record) {
      removeMaterialSupplierRows([record.id]).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message || '删除成功')
          this.selectedRowKeys = []
          this.loadData()
        } else {
          this.$message.warning(res.message || '删除失败')
        }
      })
    },
    handleBatchClear() {
      const materialIds = this.selectedMaterialIds
      if (materialIds.length === 0) {
        this.$message.warning('请先勾选商品')
        return
      }
      clearMaterialSuppliers(materialIds).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message || '清除成功')
          this.selectedRowKeys = []
          this.loadData()
        } else {
          this.$message.warning(res.message || '清除失败')
        }
      })
    },
    searchReset() {
      this.queryParam = { materialName: '', supplierId: undefined, onlyUnset: false }
      this.selectedRowKeys = []
      this.loadData(1)
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
</style>
